import { render, staticRenderFns } from "./posSummary.vue?vue&type=template&id=812aa72e&scoped=true&"
import script from "./posSummary.vue?vue&type=script&lang=js&"
export * from "./posSummary.vue?vue&type=script&lang=js&"
import style0 from "./posSummary.vue?vue&type=style&index=0&id=812aa72e&prod&scoped=true&lang=css&"
import style1 from "./posSummary.vue?vue&type=style&index=1&id=812aa72e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812aa72e",
  null
  
)

export default component.exports